module.exports = __webpack_public_path__ + "img/Mama.a95d7f47.png";